export function useMagentoCatalogAggregationsData(
  categoryId: MaybeRef<string | undefined>,
  queryVariables: {
    committedQueryVariables: Ref<any>;
  },
  options?: { key?: string },
) {
  const { committedQueryVariables: filters } = queryVariables;

  return useAggregationsData(
    computed(() => {
      const termFilter = unref(filters).term
        ? { search: unref(filters).term as string }
        : {};

      const categoryIdFilter = unref(categoryId)
        ? {
            category_uid: {
              eq: unref(categoryId),
            },
          }
        : {};

      const selectedFilters = Object.fromEntries(
        Object.entries(unref(filters).filter.selectedFiltersToSearch()).filter(
          ([, value]) => (value as any).to && (value as any).from,
        ),
      );

      return {
        ...termFilter,
        filter: {
          ...selectedFilters,
          ...categoryIdFilter,
        },
      };
    }),
    { key: options?.key },
  );
}
